export const TRUST = {
  name: "Lord Buddha Awareness And Development Foundation",
  shortName: "LBADF",
  tagline: "Empowering Communities, Upholding Human Dignity, and Inspiring Lasting Change.",
  president: "Raghubansh Singh",
  deedNo: "Deed No. 6/2024 (Book No. 4, Volume No. 1)",
  registeredAt: "Sub Registry Office, Daud Nagar, Bihar",
  regDate: "27 June 2024",
  pan: "AACTL5500A",
  urn: "AACTL5500AF20261",
  address: "Village - Deokali, Post - Obra, District - Aurangabad, Bihar - 824124",
  email: "lbaadftrust@gmail.com",
};

export const STATS = [
  { value: "18+", label: "Villages Empowered", icon: "Users" },
  { value: "45+", label: "Free Health Camps", icon: "HeartPulse" },
  { value: "12,400+", label: "Children Reached", icon: "BookOpen" },
  { value: "100%", label: "Transparent Funds", icon: "ShieldCheck" },
];

export const FOCUS_AREAS = [
  {
    id: "education",
    icon: "BookOpen",
    title: "Education & Youth Empowerment",
    tag: "Education First",
    color: "blue",
    summary:
      "Free coaching, textbooks and guidance for talented but economically weak students — bridging the rural literacy divide through village learning centres.",
    image:
      "https://images.unsplash.com/flagged/photo-1574098335395-18cf525e45d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzY2hvb2wlMjBjaGlsZHJlbiUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3OTA2OTg1NTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "healthcare",
    icon: "HeartPulse",
    title: "Healthcare & Wellness",
    tag: "Health for All",
    color: "emerald",
    summary:
      "Free medical checkup camps, maternal health counselling, sanitation drives and anti-addiction awareness programmes across underserved hamlets.",
    image:
      "https://images.unsplash.com/photo-1758691462123-8a17ae95d203?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkb2N0b3IlMjBoZWFsdGglMjBjaGVja3VwJTIwdmlsbGFnZXxlbnwwfHx8fDE3OTA2OTg1NTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "social_justice",
    icon: "Scale",
    title: "Social Justice & Women Upliftment",
    tag: "Dignity & Rights",
    color: "amber",
    summary:
      "Protecting legal & social rights of women, fighting child marriage, dowry and child labour, and running self-help & vocational training for the marginalized.",
    image:
      "https://images.unsplash.com/flagged/photo-1577604981316-298e453a19dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjb21tdW5pdHklMjBlbXBvd2VybWVudCUyMHdvbWVufGVufDB8fHx8MTc5MDY5ODU2NHww&ixlib=rb-4.1.0&q=85",
  },
];

export const VALUES = [
  { title: "Karuna", subtitle: "Compassion", desc: "Active empathy driving tangible action for those in need." },
  { title: "Pragya", subtitle: "Wisdom", desc: "Education as the supreme tool for lasting self-reliance." },
  { title: "Samata", subtitle: "Equality", desc: "Dignity and rights for every marginalized person." },
  { title: "Shuchita", subtitle: "Transparency", desc: "100% accountable public donations and honest governance." },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/flagged/photo-1574097656146-0b43b7660cb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzY2hvb2wlMjBjaGlsZHJlbiUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3OTA2OTg1NTh8MA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1760454634741-14469ef82f4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxydXJhbCUyMGVkdWNhdGlvbiUyMGluZGlhJTIwY2hpbGRyZW58ZW58MHx8fHwxNzkwNjk4NTU0fDA&ixlib=rb-4.1.0&q=85";

export const GALLERY_CATEGORIES = ["All", "Education", "Health Camps", "Social Justice", "Community Events"];
